<template>
    <div class="ml-2 text-xl">{{ $t("web-rg.selectImagesToImport") }}</div>
    <MContainer class="mt-6 ml-2 h-full" style="overflow: hidden">
        <div class="flex flex-row-wrap grow col-span-12 gap-12">
            <div
                v-for="(item, index) in params.previews"
                v-bind:key="index"
                v-bind:class="['border-2']"
                :style="{ position: 'relative', borderRadius: '8px', borderColor: item.selectedFlag ? 'white' : 'transparent' }">
                <div style="position: absolute; top: 3%; left: 3%; display: inline-block; z-index: 1">
                    <div class="flex flex-row">
                        <MUButton
                            :style="{
                                width: '20px',
                                height: '20px',
                                background: item.selectedFlag ? '#0c72c799' : '#99999999',
                            }"
                            :icon="item.selectedFlag ? 'pi pi-check' : 'pi pi-times'"
                            v-on:click="selectClickedBase(item)" />
                        <span class="ml-2 font-bold text-xl">{{ item.modality }}, {{ item.description }}</span>
                    </div>
                </div>
                <Image
                    v-bind:alt="item.fName"
                    v-bind:src="item.preview"
                    style="object-fit: cover; height: 100% !important; border-radius: 8px; position: relative"
                    :pt="{
                        image: {
                            style: {
                                background: 'transparent !important',
                                maxHeight: '17rem',
                                borderRadius: '8px',
                            },
                        },
                        previewMask: {
                            style: {
                                borderRadius: '8px',
                            },
                        },
                    }"
                    preview>
                    <template v-slot:indicatoricon>
                        <div
                            class="w-full h-full flex flex-col justify-start text-xs"
                            v-on:click="selectClicked($event, item)"
                            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 2; cursor: pointer; background: transparent">
                            <div
                                class="w-full h-full flex flex-col justify-start text-xs"
                                style="text-align: left; position: absolute; top: 30%; left: 5%; display: inline-block; white-space: pre-wrap">
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    {{ $t("web-rg.position") }}{{ item.position[0].toFixed(1) }}, {{ item.position[1].toFixed(1) }}, {{ item.position[2].toFixed(1) }}
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>{{ $t("web-rg.thickness") }}{{ item.thickness.toFixed(2) }}</span>
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>{{ $t("web-rg.dimensions") }}{{ item.dimensions[0] }}, {{ item.dimensions[1] }}</span>
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>{{ $t("web-rg.pixelDimensions") }}{{ item.pixelDimension[0].toFixed(3) }}, {{ item.pixelDimension[1].toFixed(3) }}</span>
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>{{ $t("web-rg.instanceNumber") }}{{ item.instanceNumber }}</span>
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>{{ $t("web-rg.manufacturer") }}{{ item.manufacturer }}</span>
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>{{ $t("web-rg.manufacturerModelName") }}{{ item.manufacturerModelName }}</span>
                                </div>
                                <div class="flex mb-1 mr-2 ml-2" style="height: 16px">
                                    <span>
                                        {{ $t("web-rg.studyDate") }}{{ new Date(Number(item.studyDate[0]), Number(item.studyDate[1]), Number(item.studyDate[2])).toDateString() }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </Image>
            </div>
        </div>
    </MContainer>
    <MContainer class="p-dialog-footer mt-4 h-full" style="justify-content: right !important">
        <div class="flex"><MUButton v-on:click="proceed()" v-bind:label="$t('web-rg.uploadSelected')"></MUButton></div>
    </MContainer>
</template>
<script lang="ts" setup>
import { MContainer, MUButton } from "@xlabmedical/medic-web-framework";
import type { DynamicDialogOptions } from "primevue/dynamicdialogoptions";
import { previewObject } from "@/components/RgImportProjectComponent.vue";

const dialogRef = inject("dialogRef") as DynamicDialogOptions;
const params = dialogRef.value.data as { previews: previewObject[] };

const emits = defineEmits<{ (e: "proceedToUpload", value: previewObject[]): void }>();

const proceed = () => {
    emits("proceedToUpload", params.previews);
    dialogRef.value.close();
};
function selectClicked(e: MouseEvent, item: previewObject) {
    e.preventDefault();
    e.stopPropagation();
    selectClickedBase(item);
}
function selectClickedBase(item: previewObject) {
    item.selectedFlag = ref(!item.selectedFlag);
}
</script>
<style scoped>
.items-padding > *:not(:last-child) {
    @apply pb-5;
}
.p-image img {
    border-radius: 0.75rem;
    max-height: 17rem;

    background: var(--webcad-dropdown-bg-color) !important;
}
.input-item {
    position: relative;
}
.input-item .item-wrapper {
    position: absolute;
    top: 3%;
    left: 3%;
    display: inline-block;
}
.dicom-info {
    text-align: left;
}
</style>
